module.exports = __webpack_public_path__ + "img/master-card.6db52a1e.png";